import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

export * from './confirmation-modal.service';

import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
export { ConfirmationModalComponent };

import {
  ConfirmationModalIconDirective,
  ConfirmationModalMessageDirective,
  ConfirmationModalTitleDirective,
  ConfirmationModalCustomContentDirective,
  ModalBodyComponent,
} from './modal-body/modal-body.component';
export {
  ConfirmationModalIconDirective,
  ConfirmationModalMessageDirective,
  ConfirmationModalTitleDirective,
  ConfirmationModalCustomContentDirective,
  ModalBodyComponent,
};

import {
  ConfirmationModalActionsDirective,
  ConfirmationModalSecondaryActionsDirective,
  ModalActionsComponent,
} from './modal-actions/modal-actions.component';
export { ConfirmationModalActionsDirective, ConfirmationModalSecondaryActionsDirective, ModalActionsComponent };

export const MODULE_IMPORTS_EXPORTS = [
  ConfirmationModalComponent,
  ConfirmationModalActionsDirective,
  ConfirmationModalSecondaryActionsDirective,
  ModalActionsComponent,
  ConfirmationModalIconDirective,
  ConfirmationModalMessageDirective,
  ConfirmationModalTitleDirective,
  ConfirmationModalCustomContentDirective,
  ModalBodyComponent,
];

@NgModule({
  imports: [CommonModule, MatDialogModule, ...MODULE_IMPORTS_EXPORTS],
  exports: MODULE_IMPORTS_EXPORTS,
})
export class GalaxyConfirmationModalModule {}
